import { getEffectiveStorageInfo } from 'mini-usq-store/lib/utils/getEffectiveStorageInfo';
import { getUSQStore } from 'mini-usq-store/lib/store/store';
import {
    ClientStorageState,
    StorageDetailsFetchStatus,
} from 'mini-usq-store/lib/store/schema/USQStore';

export const canShowUSQWarningCard = () => {
    const { emailStorage, microsoftStorage } = getUSQStore();
    const { state } = getEffectiveStorageInfo();
    return (
        (emailStorage.storageDetailsFetchStatus === StorageDetailsFetchStatus.SUCCESS ||
            microsoftStorage.storageDetailsFetchStatus === StorageDetailsFetchStatus.SUCCESS) &&
        state !== ClientStorageState.Normal
    );
};
